import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

/**
 * Small, persistent legal disclaimer. Placed at the bottom of
 * calculation-heavy pages (Project Dashboard, Cost Library) and links out
 * to the full /disclaimer page.
 */
export default function DisclaimerBar({ className = "" }) {
  const navigate = useNavigate();
  return (
    <div
      className={`mt-10 border-t border-black/[0.06] pt-6 ${className}`}
      data-testid="disclaimer-bar"
    >
      <div className="flex items-start gap-3 text-[11px] text-[#78716C] leading-relaxed">
        <ShieldAlert className="w-3.5 h-3.5 text-sage-700 shrink-0 mt-0.5" />
        <p>
          <strong className="text-[#1C1C1C]">Estimates only.</strong>{" "}
          All costs, profit, ROI, margin, and value-add figures shown are
          approximations based on your inputs and generic regional defaults.
          They are <strong>not</strong> a quote, valuation, or financial advice.
          Obtain independent professional advice and binding quotes before you
          commit funds.{" "}
          <button
            type="button"
            onClick={() => navigate("/disclaimer")}
            data-testid="disclaimer-bar-link"
            className="underline hover:text-[#1C1C1C]"
          >
            Read the full disclaimer
          </button>
          .
        </p>
      </div>
    </div>
  );
}
